import React from "react";
import {Select} from "antd";
import {useTranslation} from "react-i18next";
import {
    SelectionCard,
    SelectionHeader,
    SelectionTitle,
    SelectionInfo,
    StyledSelect,
    TimeSelectionRow
} from "../style/CustomerRequestsPage.styles";

const {Option} = Select;

const ShiftSelection = ({
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    totalHours,
    isActive,
    isSupportRequest = false
}) => {
    const {t} = useTranslation();

    const timeOptions = [];
    for (let i = 0; i < 24; i++) {
        const hour = i.toString().padStart(2, "0");
        timeOptions.push({value: `${hour}:00`, label: `${hour}:00`});
    }

    const isTimeOptionValid = (selectedTime, isStartTime) => {
        if (!selectedTime) return true;

        const selectedHour = parseInt(selectedTime.split(":")[0]);
        const otherTime = isStartTime ? endTime : startTime;

        if (!otherTime) return true;

        const otherHour = parseInt(otherTime.split(":")[0]);
        let calculatedHours;

        if (isStartTime) {
            if (otherHour > selectedHour) {
                calculatedHours = otherHour - selectedHour;
            } else if (otherHour < selectedHour) {
                calculatedHours = 24 - selectedHour + otherHour;
            } else {
                calculatedHours = 0;
            }
        } else {
            if (selectedHour > otherHour) {
                calculatedHours = selectedHour - otherHour;
            } else if (selectedHour < otherHour) {
                calculatedHours = 24 - otherHour + selectedHour;
            } else {
                calculatedHours = 0;
            }
        }

        if (isSupportRequest) {
            return calculatedHours >= 10;
        }

        // For planning requests, check 10-13 hours range
        return calculatedHours >= 10 && calculatedHours <= 13;
    };

    const shiftHoursHint = isSupportRequest
        ? t("screens.customerRequests.supportShiftHoursMustBeAtLeast10")
        : t("screens.customerRequests.shiftHoursMustBeBetween10And13");
    const shouldShowHint = isSupportRequest || totalHours < 1;


    return (
        <SelectionCard $disabled={!isActive}>
            <SelectionHeader>
                <SelectionTitle>
                    1. {t("screens.customerRequests.shiftSelection")}{" "}
                    {shouldShowHint ? (
                        <span style={{fontSize: "12px", color: "#666"}}>({shiftHoursHint})</span>
                    ) : null}
                </SelectionTitle>
                {totalHours > 0 && (
                    <SelectionInfo>
                        {t("screens.customerRequests.totalHours", {count: totalHours})}
                    </SelectionInfo>
                )}
            </SelectionHeader>
            <TimeSelectionRow>
                <div style={{flex: 1}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: 500,
                            fontSize: "14px"
                        }}
                    >
                        {t("screens.customerRequests.startTime")}
                    </label>
                    <StyledSelect
                        placeholder={t("screens.customerRequests.selectStartTime")}
                        value={startTime}
                        onChange={setStartTime}
                        style={{width: "100%"}}
                        disabled={!isActive}
                        allowClear={true}
                    >
                        {timeOptions.map(time => (
                            <Option
                                key={time.value}
                                value={time.value}
                                disabled={!isTimeOptionValid(time.value, true)}
                            >
                                {time.label}
                            </Option>
                        ))}
                    </StyledSelect>
                </div>
                <div style={{flex: 1}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: 500,
                            fontSize: "14px"
                        }}
                    >
                        {t("screens.customerRequests.endTime")}
                    </label>
                    <StyledSelect
                        placeholder={t("screens.customerRequests.selectEndTime")}
                        value={endTime}
                        onChange={setEndTime}
                        style={{width: "100%"}}
                        disabled={!isActive}
                        allowClear={true}
                    >
                        {timeOptions.map(time => (
                            <Option
                                key={time.value}
                                value={time.value}
                                disabled={!isTimeOptionValid(time.value, false)}
                            >
                                {time.label}
                            </Option>
                        ))}
                    </StyledSelect>
                </div>
            </TimeSelectionRow>
        </SelectionCard>
    );
};

export default ShiftSelection;
